import {EDIT_DATA_SELECTED, SAVE_ALL_CONTRACT, SAVE_TABLE_DATA,SAVE_INFO_FACTOR_CONTRACT} from "../actionTypes";

export const changeContract = (contractData) => (dispatch) => {
    dispatch({
        type: SAVE_ALL_CONTRACT,
        contractData: contractData,
    });
};
export const changeTableData = (tableDataContract) => (dispatch) => {
    dispatch({
        type: SAVE_TABLE_DATA,
        tableDataContract: tableDataContract,
    });
};

export const editDataSelected = (editRecord) => (dispatch) => {
    dispatch({
        type: EDIT_DATA_SELECTED,
        editRecord,
    });
};
export const setInfoFactorContract = (infoFactorContract) => (dispatch) => {
  dispatch({
    type: SAVE_INFO_FACTOR_CONTRACT,
    infoFactorContract,
  });
};